<template>
  <div class="container_box">
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button type="primary" class="mr15" v-if="getPermission('ymsProductTag_create')"
        @click="editProductLabel('add')">{{ $t('key1003206') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="tableDom"
        highlight-row
        border
        max-height="650"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--创建标签弹窗-->
    <Modal v-model="productLabelModal" :title="productLabelTitle" width="600"
      :transfer="false" :mask-closable="false" @on-visible-change="productLabelChange">
      <Form ref="productLabelForm" :model="productLabelForm" :label-width="120" @submit.native.prevent>
        <Row>
          <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
            <template v-for="item in multilingualNamesList">
              <template :slot="item.name">
                <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <Form-item :label="labelRander(item)" :prop="'name_' + item.code" :rules="getRules(item)">
                    <Input clearable v-model.trim="productLabelForm['name_' + item.code]" class="wid100P"></Input>
                  </Form-item>
                </Col>
              </template>
            </template>
          </languagesTabs>
          <Divider/>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003210')" prop="remark">
              <Input v-model.trim="productLabelForm.remark" type="textarea" :autosize="{ minRows: 3, maxRows: 8}"></Input>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <Button @click="productLabelModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="productLabelBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllUsersInfo, getUserNameByUserId, isJSON} from "@/utils/common";
import languagesTabs from "@/components/common/languagesTabs.vue";

export default {
  name: 'productLabel',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      columns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003294'),
          key: 'productNumber',
          minWidth: 130,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          align: 'left',
          minWidth: 170,
          key: 'createdTime',
          render(h, params) {
            let createdTime = params.row.createdTime;
            return h('span', v.$uDate.dealTime(createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          key: 'createdBy',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003220'),
          key: 'remark',
          width: 300,
          align: 'left',
          render(h, params) {
            let remark = params.row.remark;
            return v.checkContentOverflow(h, remark, 300, 2);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 220,
          align: 'left',
          render: (h, params) => {
            let ymsProductTagId = params.row.ymsProductTagId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsProductTag_update'),
                    clickFn: () => {
                      v.editProductLabel('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: v.getPermission('ymsProductTag_delete'),
                    clickFn: () => {
                      v.deleteProductLabelBtn(ymsProductTagId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableColumns: [],
      tableData: [],
      productLabelModal: false,
      productLabelTitle: '',
      productLabelType: 'add',
      productLabelForm: {
        remark: ''
      },
      ruleValidate: {
        name_0: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003295'), trigger: 'blur'}
        ]
      },
      labelRander: (params) => {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003296') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424');
      },
      ymsProductTagId: null,
      userInfoList:{}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      v.initMultilingualFields('productLabelForm', this.productLabelForm, ['name_']);
      (async () => {
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await v.getList();
      })();
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.handleColumns();
      v.optionBtnWidth = [];
      v.tableData = [];
      if (v.getPermission('ymsProductTag_queryList')) {
        v.tableLoading = true;
        v.axios.get(api.get_ymsProductTag_queryList).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            v.tableData = data;
            v.updateTableDom('tableDom');
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 删除标签
    deleteProductLabelBtn(ymsProductTagId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003221'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003297'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001444'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.delete(api.delete_ymsProductTag_delete + ymsProductTagId, null, {
            loading: true,
            loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
          }).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002957'));
              v.getList();
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 编辑标签
    editProductLabel(type, item) {
      let obj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003206'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003207')
      };
      this.productLabelTitle = obj[type];
      this.productLabelType = type;
      if (type === 'edit') {
        this.productLabelForm.remark = item.remark;
        this.ymsProductTagId = item.ymsProductTagId;
        let name = item.name;
        if (name) {
          if (isJSON(name)) {
            let obj = JSON.parse(name);
            for (let key in obj) {
              this.productLabelForm['name_' + key] = obj[key];
            }
          } else {
            this.productLabelForm['name_CN'] = name;
          }
        }
      }
      this.productLabelModal = true;
    },
    // 确定按钮
    productLabelBtn() {
      let v = this;
      let url = '';
      let method = 'post';
      let text = '';
      let obj = {};
      if (v.productLabelType === 'add') {
        url = api.post_ymsProductTag_create;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488');
      } else if (v.productLabelType === 'edit') {
        url = api.put_ymsProductTag_update;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
        obj.ymsProductTagId = v.ymsProductTagId;
      }
      obj.name = v.handleMultilingualSingleParam(v.productLabelForm, 'name_');
      obj.remark = v.productLabelForm.remark;
      v.$refs['productLabelForm'].validate((valid) => {
        if (valid) {
          v.axios[method](url, obj, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.productLabelModal = false;
              v.$Message.success(text);
              v.getList();
            }
          });
        }
      });
    },
    // 监听弹窗
    productLabelChange(value) {
      if (!value) {
        this.$refs['productLabelForm'].resetFields();
        this.productLabelType = 'add';
        this.distributorsTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003206');
        this.ymsProductTagId = null;
      } else {
        this.$refs['languagesTab'].tabName = this.languagesVal;
      }
    },
    // 设置表单必填项校验规则
    getRules(item) {
      let list = [];
      if (item.required) {
        list = [
          {required: true, message: item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003295'), trigger: 'blur'}
        ];
      }
      return list;
    },
    // 处理列表字段
    handleColumns() {
      let v = this;
      v.tableColumns = [];
      let list = [];
      if (v.multilingualNamesList.length > 0) {
        v.multilingualNamesList.map((item) => {
          let key = 'name_' + item.code;
          let text = '';
          list.push({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003296') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002818'),
            key: key,
            align: 'left',
            minWidth: 150,
            render(h, params) {
              let name = params.row.name;
              if (name) {
                if (isJSON(name)) {
                  let obj = JSON.parse(name);
                  text = obj[item.code];
                } else {
                  text = '';
                  if (item.code === 'zh-CN') {
                    text = name;
                  }
                }
              }
              return h('span', text);
            }
          });
        });
      }
      if (list.length > 0) {
        v.tableColumns = [...list, ...v.columns];
      }
    },
  },
  watch: {},
  components: {languagesTabs}
};
</script>

<style lang="less">

</style>
